import { JobGroupCode } from '@domain/constant/filterType';
import { JobTypeCode } from '@domain/constant/jobType';
import {
  InterviewHistoryListItemDto,
  InterviewHistoryListRs,
} from '@domain/rs/pass/interview/history/InterviewHistoryListRs';
import DateFormat from '@utils/date/format';

export default class InterviewHistoryListDisplayVO {
  list: InterviewHistoryDateVO[];

  constructor(data: InterviewHistoryListRs) {
    const mapObject = data.practiceRecordQuestionsByDate;
    const sortedKeys = Object.keys(mapObject).sort((a, b) => {
      const dateA = new Date(a).valueOf();
      const dateB = new Date(b).valueOf();
      return dateB - dateA; // 내림차순 정렬
    });

    // 정렬된 키를 사용하여 InterviewHistoryDateVO 인스턴스의 배열 생성
    this.list = sortedKeys.map((key) => {
      const date = new Date(key);
      return new InterviewHistoryDateVO(date, mapObject[key]);
    });
  }
}

export class InterviewHistoryDateVO {
  displayDate: string;
  cards: InterviewHistoryListItemVO[];

  constructor(date: Date, items: InterviewHistoryListItemDto[]) {
    this.displayDate = DateFormat.format(date, 'yyyy.MM.dd(week)');
    this.cards = items.map((item) => new InterviewHistoryListItemVO(item));
  }
}

export class InterviewHistoryListItemVO {
  id: number;
  playTime: string;
  badgeTitle: string;
  questionText: string;
  answerVideoUrl: string;
  passReviewCompanySn: number | null;
  jobTypeText: string | null;
  jobTitleText: string | null;
  dateTime: string;

  constructor(dto: InterviewHistoryListItemDto) {
    this.id = dto.practiceQuestionSn;
    this.playTime = this.secondsToMinSec(dto.playTime);
    this.badgeTitle = dto.badgeTitle;
    this.questionText = dto.questionText;
    this.answerVideoUrl = dto.answerVideoUrl;
    this.passReviewCompanySn = dto.passReviewCompanySn;
    this.jobTypeText = this.getJobTypeText(dto.jobTypeCode);
    this.jobTitleText = this.jobGroup(dto.jobGroupCode);
    this.dateTime = dto.dateTime;
  }

  private secondsToMinSec(sec: number) {
    const zeroFiled = (value: number) => (value < 10 ? '0' + value : value);
    const tempSeconds = sec % 60;
    const minute = Math.floor(sec / 60);
    const plusSeconds = sec - 60 * minute - tempSeconds > 0.5 ? 1 : 0;
    const sum = plusSeconds + tempSeconds + minute * 60;

    return `${zeroFiled(Math.floor(sum / 60))}:${zeroFiled(sum % 60)}`;
  }

  private getJobTypeText = (jobTypeCode: JobTypeCode | null) => {
    if (!jobTypeCode) return '';
    switch (jobTypeCode) {
      case JobTypeCode.NEW:
        return '신입';
      case JobTypeCode.CAREER:
        return '경력';
      case JobTypeCode.INTERNSHIP:
        return '인턴';
    }
  };

  private jobGroup = (jobGroupCode: JobGroupCode | null) => {
    if (!jobGroupCode) return '';

    switch (jobGroupCode) {
      case JobGroupCode.COMMON:
        return '직군 공통';
      case JobGroupCode.SALES:
        return '영업';
      case JobGroupCode.RESEARCH:
        return '연구 · 개발';
      case JobGroupCode.MANAGEMENT:
        return '경영기획 · 지원';
      case JobGroupCode.MARKETING:
        return '홍보 · 마케팅';
      case JobGroupCode.PRODUCTION:
        return '생산 · 유통 · 품질';
      case JobGroupCode.ENGINEER:
        return '건설 엔지니어';
      case JobGroupCode.IT:
        return 'IT 서비스';
      case JobGroupCode.DESIGN:
        return '디자인';
      case JobGroupCode.CS:
        return '서비스 · 고객지원';
      case JobGroupCode.FINANCE:
        return '금융 · 보험';
      case JobGroupCode.MEDICAL:
        return '의료 · 보건';
      default:
        return '';
    }
  };
}
